<svg width="303" height="279" viewBox="0 0 303 279" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="96.4942" cy="96.4942" r="96.3709" fill="url(#paint0_linear_249_110)"/>
<circle cx="259.563" cy="203.778" r="42.9963" fill="url(#paint1_linear_249_110)"/>
<circle cx="132.175" cy="247.175" r="30.8837" transform="rotate(90 132.175 247.175)" fill="url(#paint2_linear_249_110)"/>
<defs>
<linearGradient id="paint0_linear_249_110" x1="96.4942" y1="192.865" x2="502.006" y2="-332.419" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
<linearGradient id="paint1_linear_249_110" x1="259.563" y1="246.774" x2="148.066" y2="82.3492" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
<linearGradient id="paint2_linear_249_110" x1="132.175" y1="278.059" x2="52.0888" y2="159.954" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
</defs>
</svg>
